<template>
  <div class="help-center">

    <!-- HERO SEARCH -->
    <section class="help-hero" style="background-image:url(/images/help-center-header.jpg);">
      <div class="overlay">
        <div class="row column">
          <h1>Resident Information Center</h1>
          <div class="search">
            <v-icon>search</v-icon>
            <input type="search" @focus="hideTyper">
            <vue-typer
              ref="typer"
              :text="searchIdeas"
              :shuffle="true"
              :typeDelay="150">
            </vue-typer>
          </div>
        </div>
      </div>
    </section>

    <!-- ALERTS -->
    <section class="alerts">
      <div class="row">
        <div class="medium-4 small-12 columns">
          <h5>Real-time</h5>
          <h4>Alerts &amp; Notifications</h4>
        </div>
        <div class="medium-8 small-12 columns">
          <div class="alerts-slider">
            <slick ref="slick" :options="alertsSliderOptions">
              <div class="slide" v-for="(alert, index) in alerts" :key="index">
                <time>{{ alert.time }}</time>
                <p>{{ alert.message }}</p>
              </div>
            </slick>
            <button class="prev" @click="prevAlert"><img src="/images/chevron-left.png"></button>
            <button class="next" @click="nextAlert"><img src="/images/chevron-right.png"></button>
          </div>
        </div>
      </div>
    </section>

    <!-- VIDEO SOLUTIONS -->
    <section class="videos" id="videos">
      <div class="row column">
        <h2>Video Solutions</h2>
        <p>Find solutions, set up instructions, troubleshooting steps, and helpful tips specific to you.</p>
      </div>
      <div class="row align-center">
        <div class="medium-10 small-12 columns">
          <div class="tiles">
            <div class="tile" v-for="(video, index) in videos" :key="index" @click="showVideo(video.url)">
              <div>
                <img :src="video.logo">
              </div>
            </div>
          </div>
        </div>
      </div>
      <v-dialog v-model="videoPopup" max-width="960" persistent>
        <div class="video-popup">
          <v-btn fab small flat class="close-button" @click="videoPopup = false">
            <v-icon large>close</v-icon>
          </v-btn>
          <div class="video-container">
            <iframe :src="activeVideo" frameborder="0" allowfullscreen></iframe>
          </div>
        </div>
      </v-dialog>
    </section>

    <!-- FAQS -->
    <section class="faqs" id="faqs">
      <div class="row column">
        <h2>Frequently Asked Questions.</h2>
      </div>
      <!-- Tabs for Desktop-->
      <div class="faqs faqs--tabs">
        <div class="row">
          <div class="medium-7 small-12 columns">
            <ul class="questions">
              <li v-for="(faq, index) in faqs" :key="index" :id="index" :class="{ active: index == activeFaq.id }">
                <button @click="setActiveFaq(faq)">{{ faq.question }}</button>
              </li>
            </ul>
          </div>
          <div class="medium-5 small-12 columns answer-col" v-if="activeFaq.answer">
            <div class="answers">
              <p>{{ activeFaq.answer }}</p>
            </div>
          </div>
        </div>
      </div>
      <!-- Accordion for Mobile-->
      <div class="faqs faqs--accordion">
        <div class="row column">
          <v-expansion-panel>
            <v-expansion-panel-content v-for="(faq, index) in faqs" :key="index">
              <div slot="header">{{ faq.question }}</div>
              <v-card>
                <v-card-text><p>{{ faq.answer }}</p></v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </div>
      </div>
    </section>

    <!-- MAP & LOCATIONS -->
<!--
    <section class="locations" id="locations">
      <div class="google-map" id="locations-map"></div>
      <div class="row align-right">
        <div class="medium-6 small-12 columns">
          <div class="locator">
            <h2>
              Store Locations
              <v-progress-circular
                v-if="search.loading"
                style="margin-left: 1rem;"
                indeterminate
                color="primary"
              ></v-progress-circular>
            </h2>
            <p>Find the Charter locations closest to you by entering your zip code or address below.</p>
            <form @submit.prevent="searchLocations">
              <input type="text" name="address" id="address" placeholder="Address or Zip Code" v-model="search.address">
              <div class="break">
                <span>+</span>
              </div>
              <select v-model="search.radius">
                <option value="5">Within 5 Miles</option>
                <option value="10">Within 10 Miles</option>
                <option value="25">Within 25 Miles</option>
              </select>
              <button type="submit" class="button">Search</button>

              <v-alert
                :value="true"
                type="info"
                v-if="search.noResults"
              >
              No results found for that address
              </v-alert>
            </form>
          </div>
        </div>
      </div>
    </section>

    <section class="embed" id="guestinternet">
      <iframe src="http://charter.guestinternet.com/#/login" frameborder="0"></iframe>
    </section>
-->
  </div>
</template>

<script>
  import Slick from 'vue-slick'
  import { VueTyper } from 'vue-typer'
  import { mapStyles } from '../assets/scripts/map-styles'

  export default {
    components: { Slick, VueTyper },

    data () {
      return {
        // Hero typing entries
        searchIdeas: [
          'How can I sign the addendum?',
          'How do I find my Mac address?',
          'Can I use my Alexa?',
          'How do I connect another device?'
        ],

        // Alerts / Notifications
        alertsSliderOptions: {
          infinite: true,
          slidesToShow: 1,
          arrows: false,
          autoplay: true,
          autoplaySpeed: 4000
        },
        alerts: [
//          {
//           time: '8/29/2018 - 12:25 am',
//            message: 'The Tech Amenity is now live. Check your email for credentials.'
//          },
          {
            time: '11/01/2018 - 8:40 am',
            message: 'If you have not yet signed up for the Tech Amenity, you still have until 11/30 to do so and be entered in the prize drawing.'
          },
          {
            time: '11/08/2018 - 8:00 am',
            message: 'Visit the leasing office if you need help signing your Tech Amenity addendum.'
          }
        ],

        // Videos
        activeVideo: '',
        videoPopup: false,
        videos: [
          {
            logo: '/images/android-logo.png',
            url: 'https://www.youtube.com/embed/BCygMAsMM_c?rel=0&autoplay=1'
          },
          {
            logo: '/images/apple-logo.png',
            url: 'https://www.youtube.com/embed/tx9S92mj08M?rel=0&autoplay=1'
          },
          {
            logo: '/images/apple-tv-logo.png',
            url: 'https://www.youtube.com/embed/ujGeDGn0kU4?rel=0&autoplay=1'
          },
          {
            logo: '/images/xbox-logo.png',
            url: 'https://www.youtube.com/embed/0HZC96ZK7s0?rel=0&autoplay=1'
          },
          {
            logo: '/images/roku-logo.png',
            url: 'https://www.youtube.com/embed/Y04obsEJsdQ?rel=0&autoplay=1'
          }
        ],

        // FAQs
        activeFaq: {},
        faqs: [
          {
            id: 0,
            question: 'How do I sign up?',
            answer: 'To sign up for the new Tech Amenity and take advantage of the available incentives, come to the management office or log on to your Resident Portal to e-sign the Tech Amenity addendum. The charges will not begin until after your complimentary month of free service after project completion.'
          },
          {
            id: 1,
            question: 'What does the Tech Amenity service provide?',
            answer: 'The Tech Amenity service provides exclusive high-speed internet. This package includes up to 300 Mbps wired and wireless internet. The service also includes US based dedicated Customer Support.'
          },
          {
            id: 2,
            question: 'What are my Options?',
            answer: 'Option 1.) Sign up for the new Tech Amenity and take advantage of the first free month after project completion. If you are required to pay a cancellation fee from your current provider, bring evidence of the charge to the management office and we will reimburse the cancellation fees. Contact the management office for full details. Option 2.) Keep your existing service provider through the end of your current lease. The Tech Amenity charge is required for new leases or upon renewal for current residents. If you wait until your renewal, the monthly charge will automatically start at the beginning of the renewal period.'
          },
          {
            id: 3,
            question: 'What if I need a direct or wired connection?',
            answer: 'Each apartment will have one ethernet port installed for direct connections at speeds up to 300 Mbps.'
          },
          {
            id: 4,
            question: 'How do I sign on to the internet once the project is complete?',
            answer: 'If you have signed the Tech Amenity addendum you will be given your own unique username and password that will allow you to log in to the new service. You will have to sign in one time on each device with your unique username and password.'
          },
          {
            id: 5,
            question: 'When do I need to start paying the Tech Amenity charge?',
            answer: 'The Tech Amenity charge will take effect 30 days after the Tech Amenity goes live and be paid along with your rent.'
          },
          {
            id: 6,
            question: 'Is the network secure?',
            answer: 'Yes. When you sign into your network, only devices you register with your credentials will be authenticated and authorized to use the network. Devices in your personal group will be able to communicate with each other, but no other user on the network will be able to “see” your devices.'
          },
          {
            id: 7,
            question: 'Can I add MAC addresses for my devices?',
            answer: 'You will be able to call the 24/7 Support Line to add any MAC addresses for devices on your VLAN (Virtual Local Area Network).'
          },
          {
            id: 8,
            question: 'Will I be able to make VOIP calls with the Tech Amenity?',
            answer: 'Yes, you are able to contract a VoIP service such as Vonage, or any other VoIP provider, and plug the device into the provided ethernet port to connect.'
          }
        ],

        // Map / Locations
        search: {
          address: null,
          defaultAddress: '2543 Meridian Pkwy, Durham, NC 27713',
          radius: 10,
          location: {
            lat: 35.910810,
            lng: -78.903310
          },
          noResults: false,
          loading: false
        },
        markerCoordinates: [],
        map: null,
        bounds: null,
        markers: []
      }
    },

    methods: {
      prevAlert () {
        this.$refs.slick.prev()
      },

      nextAlert () {
        this.$refs.slick.next()
      },

      showVideo (url) {
        this.activeVideo = url
        this.videoPopup = true
      },

      setActiveFaq (faq) {
        this.activeFaq = faq
      },

      hideTyper () {
        this.$refs.typer.$el.classList.add('hide')
      },

      searchLocations () {
        this.markerCoordinates = [];
        this.markers = [];
        this.search.loading = true;

        let address = this.search.address ? this.search.address : this.search.defaultAddress;

        $.ajax({
          url: 'https://maps.googleapis.com/maps/api/geocode/json',
          data: {
            address: address,
            key: 'AIzaSyBwPhe_Xns9yX9z_zRbosKEuEvFLVUVJKA'
          }
        })
        .done(({results}) => {

          // Get Lat/Lng from Address/Zip entered
          let lat = results[0].geometry.location.lat
          let lng = results[0].geometry.location.lng

          let location = new google.maps.LatLng(lat,lng)

          let request = {
            location: location,
            radius: this.search.radius * 1609.344,
            keyword: 'spectrum cable store'
          }

          let places = new google.maps.places.PlacesService(this.map)

          places.nearbySearch(request, (response) => {

            this.search.loading = false;

            response.filter((location) => {
              if (location.name.toLowerCase().includes('spectrum')) {
                this.markerCoordinates.push(location);
              }
            });

            if (this.markerCoordinates.length) {
              this.initMap()
              this.search.noResults = false;
            } else {
              this.centerMap(lat, lng)
              this.search.noResults = true;
            }

          })

        })

        .catch((err) => {
          this.search.noResults = true;
          this.search.loading = false;
        })
      },

      centerMap(lat, lng) {
        // Map Bounds
        this.bounds = new google.maps.LatLngBounds();

        // Map Element
        const element = document.getElementById('locations-map')

        // Map Options
        const options = {
          zoom: 13,
          center: new google.maps.LatLng(lat,lng),
          streetViewControl: false,
          mapTypeControl: false,
          fullscreenControl: false,
          styles: mapStyles
        }

        // Set Map
        this.map = new google.maps.Map(element, options)
      },

      setMarkers () {
        // Set Markers
        let itemsProcessed = 0;

        let set = new Promise((resolve, reject) => {
          this.markerCoordinates.forEach((coord) => {
            let $_ = $

            // Marker Positions
            let position = new google.maps.LatLng(coord.geometry.location.lat(), coord.geometry.location.lng())

            // Marker Set
            let marker = new google.maps.Marker({
              map: this.map,
              position
            })

            // Add markers to data property
            this.markers.push(marker)

            // Create infowindow
            let infowindow = new google.maps.InfoWindow();

            // Populate infowindow with content
            let content = `
            <div>
            <strong>${coord.name}</strong><br>
            ${coord.vicinity}
            </div>`

            // Infowindow popup click event
            marker.addListener('mouseover', function() {
              infowindow.setContent(content);
              infowindow.open(this.map, marker);
            });

            marker.addListener('mouseout', function() {
              infowindow.close(this.map, marker);
            });

            // Fit to boundaries
            this.bounds.extend(position)

            itemsProcessed++;

            if(itemsProcessed === this.markerCoordinates.length) {
              resolve();
            }
          })
        })

        set.then(() => {
          if (this.markerCoordinates.length) {
            this.map.fitBounds(this.bounds)
          }
        })

      },

      reloadMarkers () {
        // Remove any existing markers
        this.markers.forEach((marker) => {
          marker.setMap(null)
        })
        this.markers = []

        // Set new markers
        this.setMarkers()
      },

      initMap () {
        // Map Bounds
        this.bounds = new google.maps.LatLngBounds();

        // Map Element
        const element = document.getElementById('locations-map')

        // Map Options
        const options = {
          zoom: 12,
          center: new google.maps.LatLng(35.910810,-78.903310),
          streetViewControl: false,
          mapTypeControl: false,
          fullscreenControl: false,
          styles: mapStyles
        }

        // Set Map
        this.map = new google.maps.Map(element, options)

        this.setMarkers()
      }

    },

    mounted () {
      this.initMap()
      this.searchLocations()
    }
  }
</script>
